import { useIntl } from 'react-intl'

import type { PlansTableElement } from '../../consts'
import PlansTableItem from '../PlansTableItem'
import {
  SubscriptionTableRowContainer,
  SubscriptionTableRowEssentials,
  SubscriptionTableRowFeatures,
  SubscriptionTableRowIncluded,
  SubscriptionTableRowNote,
} from './styles'
import { subscriptionTableMessages } from '../messages'

interface SubscriptionTableRowProps {
  features: string
  note?: string
  included: string
  essentials: string
  isBasicHomePlan: boolean
}

function SubscriptionTableRow({
  features,
  note,
  included,
  essentials,
  isBasicHomePlan,
}: SubscriptionTableRowProps) {
  const { formatMessage } = useIntl()
  console.log(
    features,
    ' ',
    subscriptionTableMessages[
      features as keyof typeof subscriptionTableMessages
    ]
  )
  console.log(note)

  return (
    <SubscriptionTableRowContainer>
      <SubscriptionTableRowFeatures>
        {formatMessage(
          subscriptionTableMessages[
            features as keyof typeof subscriptionTableMessages
          ]
        )}
        {note && (
          <>
            <br />

            <SubscriptionTableRowNote>
              {formatMessage(
                subscriptionTableMessages[
                  note as keyof typeof subscriptionTableMessages
                ]
              )}
            </SubscriptionTableRowNote>
          </>
        )}
      </SubscriptionTableRowFeatures>
      <SubscriptionTableRowIncluded isBasicHomePlan={!isBasicHomePlan}>
        <PlansTableItem
          item={included as PlansTableElement}
          colorful={!isBasicHomePlan}
        />
      </SubscriptionTableRowIncluded>
      <SubscriptionTableRowEssentials isBasicHomePlan={isBasicHomePlan}>
        <PlansTableItem
          item={essentials as PlansTableElement}
          colorful={isBasicHomePlan}
        />
      </SubscriptionTableRowEssentials>
    </SubscriptionTableRowContainer>
  )
}

export default SubscriptionTableRow
